import { pickExcluding, sampleN, shuffle } from "./random";

export const WEIGHT_STEPS = [1, 2, 3];
export const nextWeight = (w = 1) => WEIGHT_STEPS[(WEIGHT_STEPS.indexOf(w) + 1) % WEIGHT_STEPS.length];

export const WHEEL_MAX_SEGMENTS = 12;

export function spinList(options: string[], exclude?: string, weights: Record<string, number> = {}) {
  const weightOf = (o: string) => weights[o] ?? 1;
  const result = pickExcluding(options, exclude, weightOf);
  const labels = options.length <= WHEEL_MAX_SEGMENTS ? options : shuffle([result, ...sampleN(options.filter((o) => o !== result), WHEEL_MAX_SEGMENTS - 1)]);
  return { result, labels, weights: labels.map(weightOf) };
}

export const WHEEL_TEMPLATES = [
  { name: "Who pays?", options: ["You", "Me", "Split it", "Loser of rock-paper-scissors"] },
  { name: "Takeaway spots", options: ["Pizza place", "Thai", "Burger joint", "Sushi bar", "Curry house"] },
  { name: "Weekend plan", options: ["Beach", "Hike", "Brunch", "Museum", "Stay in"] },
];
